export default __webpack_public_path__ + "static/media/gardener.ccc86439.png";